import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["data-cy"]
const _hoisted_2 = ["innerHTML"]

import { VIconSvg } from "@/components";
import { computed } from "vue";

interface Props {
  xPosition?: string;
  yPosition?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VNotify',
  props: {
    xPosition: { default: "right" },
    yPosition: { default: "bottom" }
  },
  setup(__props: any) {

const props = __props;

const position = computed(() => {
  return [props.yPosition, props.xPosition];
});

const getTypeIconName = (type: string) => {
  const icons = {
    success: "ShieldDone",
    error: "InfoCircle",
  };

  return icons[type];
};

return (_ctx: any,_cache: any) => {
  const _component_notifications = _resolveComponent("notifications")!

  return (_openBlock(), _createBlock(_component_notifications, {
    group: "notify",
    class: "notify",
    position: position.value
  }, {
    body: _withCtx(({ item, close: onClickClose }) => [
      _createElementVNode("div", {
        "data-cy": `${item.type}-notify`,
        class: _normalizeClass(["notify-body", [item.type]])
      }, [
        _createVNode(_unref(VIconSvg), {
          class: "type-icon",
          name: getTypeIconName(item.type),
          color: "white",
          "color-tag": "stroke",
          size: "sm"
        }, null, 8, ["name"]),
        _createElementVNode("div", {
          class: "content",
          innerHTML: item.text
        }, null, 8, _hoisted_2),
        _createVNode(_unref(VIconSvg), {
          class: "close-icon",
          name: "CloseSquare",
          color: "white",
          "color-tag": "stroke",
          size: "sm",
          onClick: onClickClose
        }, null, 8, ["onClick"])
      ], 10, _hoisted_1)
    ]),
    _: 1
  }, 8, ["position"]))
}
}

})